import React from 'react';

const MyReview = () => {
    return (
        <div>
            <h1>Review</h1>
        </div>
    );
};

export default MyReview;